import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileErrorIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H10.0967C10.6489 20 11.0967 20.4477 11.0967 21C11.0967 21.5523 10.6489 22 10.0967 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H13.5858C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V12.3126C20 12.8649 19.5523 13.3126 19 13.3126C18.4477 13.3126 18 12.8649 18 12.3126V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421ZM13.2903 15.3053C13.6808 14.9148 14.314 14.9148 14.7045 15.3053L16.4723 17.073L18.2401 15.3053C18.6306 14.9148 19.2638 14.9148 19.6543 15.3053C20.0448 15.6958 20.0448 16.329 19.6543 16.7195L17.8865 18.4873L19.6543 20.255C20.0448 20.6455 20.0448 21.2787 19.6543 21.6692C19.2638 22.0598 18.6306 22.0598 18.2401 21.6692L16.4723 19.9015L14.7045 21.6692C14.314 22.0598 13.6808 22.0598 13.2903 21.6692C12.8998 21.2787 12.8998 20.6455 13.2903 20.255L15.0581 18.4873L13.2903 16.7195C12.8998 16.329 12.8998 15.6958 13.2903 15.3053Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FileErrorIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileErrorIcon);
